<div class="go-back-button" (click)="goBack()"><i class="icon"></i></div>
